import { Flex, Result, Typography } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Link } from 'components/mvp-typography';
import { QAPanelTemplate } from 'features/patient/assessment/assessment-controller/_components/questionnaire-qa-panel';
import { useGetInvoice } from 'lib/hooks/tanstack/use-getInvoice';
import { useMemo } from 'react';
export interface BillingReceiptContentProps {
  invoiceId: string;
  invoiceNumber: string;
  date: string;
  price: {
    /**
     * Price in cents
     */
    value: number;
    currency: 'CAD' | 'USD';
  };
  onExit: () => void;
}

type InvoiceStatusProps = Pick<BillingReceiptContentProps, 'invoiceId'>;

function InvoiceStatus(props: InvoiceStatusProps) {
  const invoiceQuery = useGetInvoice(props.invoiceId);

  if (invoiceQuery.isLoading) {
    return (
      <Typography.Paragraph type="secondary">
        Fetching invoice link...
      </Typography.Paragraph>
    );
  }

  if (invoiceQuery.isError) {
    return (
      <Typography.Paragraph>
        The invoice will be available in your payment method settings page.
        <QAPanelTemplate>
          <BaseButton
            onClick={() => invoiceQuery.refetch()}
            loading={invoiceQuery.isLoading}
          >
            Retry
          </BaseButton>
        </QAPanelTemplate>
      </Typography.Paragraph>
    );
  }

  return (
    <Link
      href={invoiceQuery.data?.invoiceUrl}
      target="_blank"
      disabled={!invoiceQuery.data?.invoiceUrl}
    >
      Download invoice
    </Link>
  );
}

export function BillingReceiptContent(props: BillingReceiptContentProps) {
  const price = useMemo(
    () =>
      Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: props.price.currency
      }).format(props.price.value / 100),
    [props.price.currency, props.price.value]
  );

  console.debug(props.price.currency)

  return (
    <Flex vertical gap={16} justify="center" align="center">
      <Flex vertical gap={0}>
        <Result status={'success'} />
        <div style={{ maxWidth: '400px' }}>
          <Typography.Title level={2}>{price}</Typography.Title>
          <Typography.Title level={2} style={{ marginTop: 0 }}>
            Purchase successful
          </Typography.Title>
          <Typography.Paragraph>
            Invoice number: {props.invoiceId}
          </Typography.Paragraph>
          <InvoiceStatus invoiceId={props.invoiceId} />
          <Typography.Paragraph>
            Payment date: {props.date}
          </Typography.Paragraph>
        </div>
      </Flex>
      <Flex justify="center" gap={16}>
        <BaseButton onClick={props.onExit}>Exit</BaseButton>
      </Flex>
    </Flex>
  );
}
